// Reports a Google Ads conversion when a user signs up. The gtag.js base tag is
// installed in index.html (all environments), so this is gated to production
// explicitly to avoid counting local/staging test signups as conversions.
const SIGNUP_CONVERSION_SEND_TO = 'AW-18062526324/fLCqCMuU4LEcEPSO8aRD';

// transactionId should be the new user's id so Google counts each signup only once.
// email feeds enhanced conversions: the conversion fires on pages where the email
// isn't in the DOM (OAuth popup, magic-link verify), so the Google tag's automatic
// collection finds nothing unless we provide it explicitly. gtag hashes it
// client-side before sending.
export function reportSignupConversion(transactionId = '', email = '') {
  if (import.meta.env.VITE_ENVIRONMENT !== 'production') return;
  if (typeof window.gtag !== 'function') return;
  if (email) {
    window.gtag('set', 'user_data', { email });
  }
  window.gtag('event', 'conversion', {
    send_to: SIGNUP_CONVERSION_SEND_TO,
    value: 1.0,
    currency: 'USD',
    transaction_id: transactionId,
  });
}

// send_to for the "Paid subscription activated" conversion action (secondary,
// observation-only for now).
const ACTIVATION_CONVERSION_SEND_TO = 'AW-18062526324/-jDXCPTz3M8cEPSO8aRD';

// Reports a conversion when an account's paid (non-trial) subscription is first
// seen active — a much stronger signal than the $1.00 signup, hence the higher
// value. Fired from the post-checkout subscription status check, which runs once
// per app load for paid subscribers; Google collapses repeats to one conversion
// via transaction_id (the Stripe subscription id).
export function reportActivationConversion(stripeSubscriptionId = '', email = '') {
  if (import.meta.env.VITE_ENVIRONMENT !== 'production') return;
  if (typeof window.gtag !== 'function') return;
  if (!stripeSubscriptionId) return;
  if (email) {
    window.gtag('set', 'user_data', { email });
  }
  window.gtag('event', 'conversion', {
    send_to: ACTIVATION_CONVERSION_SEND_TO,
    value: 10.0,
    currency: 'USD',
    transaction_id: stripeSubscriptionId,
  });
}
